import { useEffect } from "react"
import {
  brazeInitialise,
  conditionsMetToTrackUser,
} from "@theconversation/shared-components/braze-tc"
import { getRuntimeConfig } from "common/lib/runtimeConfig"
import { nonProdLogger } from "@theconversation/shared-components/nonProdLogger"

export const BrazeConditionalLoader = () => {
  const runtimeConfig = getRuntimeConfig()
  const sdkEndpoint = process.env.NEXT_PUBLIC_BRAZE_SDK_ENDPOINT ?? ""
  const apiKey = runtimeConfig.BRAZE_WEB_API_KEY
  const brazeSdkEnabled = runtimeConfig.BRAZE_WEB_SDK_ENABLED

  useEffect(() => {
    if (brazeSdkEnabled == "true") {
      conditionsMetToTrackUser().then((result) => {
        if (result) {
          nonProdLogger("Initialising Braze SDK")
          brazeInitialise(sdkEndpoint, apiKey)
        }
      })
    }
  }, [brazeSdkEnabled, sdkEndpoint, apiKey])

  return <></>
}
